import ajax from './ajax'
// 1.基础路径
// const BASE_URL = '/api'
// const BASE_URL = 'http://119.23.153.13:8086'
// 用户名登录
export const pwdLogin=(username,password)=>ajax( '/login',{username,password},'POST');
// 退出登录
export const logout=()=>ajax( '/logout');
// 用户注册
export const getRegister=(username,password,phone,province,school,sxkm,zylb,wscore,zscore,year,cardNum,cardPwd,zxkma,zxkmb)=>ajax( '/registered',{username,password,phone,province,school,sxkm,zylb,wscore,zscore,year,cardNum,cardPwd,zxkma,zxkmb},'POST');
// 修改密码
export const updatePwd=(uid,password)=>ajax( '/modifyPassword',{uid,password},'POST');
// 忘记密码-找回密码
export const updateForgetPwd=(user)=>ajax( '/updatePWDByPhone', user, 'POST');
// 修改分数
export const updateScore =(yhid,gkfsxg,kl,zylb,wscore,zscore,zxkm)=>ajax( '/modifyScore',{yhid,gkfsxg,kl,zylb,wscore,zscore, zxkm},'POST');
// 根据ID获取用户信息
export const getUserInfo =(yhid)=>ajax('/getUserByid/' + yhid);
// 查询省市区
export const getAreaAll =(supercode,level,isopen)=>ajax('/queryAreaAll/' + supercode + '/'+ level +'/'+ isopen);
//获取学校
export const getSchool =(areacode)=>ajax( '/querySchoolAll/' + areacode);
// 加载专业类别
export const getZyTypes =()=>ajax( '/getType');
// 获取用户收藏院校
export const getCollectSchool =(params)=>ajax('/queryCollegeTableByUid/' + params.uid + "/" + params.pageNum);
// 添加院校收藏
export const addCollectSchool =(yhid,collegeid)=>ajax( '/addUserCollection',{uid:yhid,collegeid},'POST');
// 删除用户收藏院校
export const removeCollectSchool =(params)=>ajax( '/deleteUserCollection/' + (params.uid||params.yhid) + "/" + params.collegeid,{params},'DELETE');

// 批量删除全部收藏院校
export const removeCollectSchoolList =(uid)=>ajax( '/deleteAllCollection/' + uid,{},'DELETE');
// 查询商品信息
export const getProductinfo = ()=>ajax( '/artAliPay/getPrice');

// 在线购卡短息验证码
export const phoneMsg = (PhoneNumber)=>ajax( '/artMsg/aliMsg/' + PhoneNumber);
// 确认购买接口
export const confirmPurchase = (codeid,verification_code,PhoneNumber)=>ajax( '/artMsg/verification/' + codeid + "/"+ verification_code+"/"+PhoneNumber);
// 支付宝
export const zhifubaoPay = (PhoneNumber)=>ajax( '/artAliPay/pay/' + PhoneNumber);
// 微信
export const weixinPay = (PhoneNumber)=>ajax( '/artWxPay/pay/' + PhoneNumber);
// 微信支付是否成功
export const wxisSuccess = (out_trade_no)=>ajax( '/artWxPay/getOrder/' + out_trade_no);
// 招生计划
export const getPlanCondtion = ()=>ajax( '/epc/condtion');
// 查询计划结果
export const getPlanResult = (enrollmentPlan)=>ajax( '/epc/pageEnrollmentPlan',enrollmentPlan,'POST');
// 艺考生一分段结果
export const getYfdResult = (pageNum,nd,zylb,kl)=>ajax( '/epc/list/' + pageNum + '/' + nd + '/' + zylb + '/' + kl);
// 获取艺考生一分段条件
export const getNdList = ()=>ajax( '/epc/ndList');
export const getZyList = (nd)=>ajax( '/epc/zylbList',{nd});
export const getKlList = (nd)=>ajax( '/epc/klList',{nd});
// 获取文化生一分段结果
export const getWhYfdResult = (pageNum, nd, kl)=>ajax( '/epc/CulturalASegmentList/' + pageNum + '/' + nd + '/' + kl);
// 获取控制线
export const getKzxResult = (pageNum,nd,pc,kl,lb) =>ajax( '/epc/getKzxList/' + pageNum + '/' + nd + '/' + pc + '/' + kl + '/' + lb);
// 获取控制线查询条件
export const getKxzList = () =>ajax( '/epc/preGetKzx');
// 获取文化生一分段条件
export const getWhNdList = ()=>ajax( '/epc/CulturalNdList');
export const getWhKlList = ()=>ajax( '/epc/CulturalKlList');

// 专业列表
export const getMajorList = (xz)=>ajax( '/dp/getDis/' + xz);
// 查看专业详情
export const getMajorDetail = (zydm) => ajax( '/dp/getZYD/' + zydm);
// 专业开设院校
export const getMajorToSchool= (kl,zymc)=>ajax( '/dp/getDyx/'+ kl + "/"+ zymc);
// 院校查询
export const getSchoosFinder = (artSchool) => ajax( '/queryNew',artSchool,'POST');

// 修改批专业类别
export const updateKL = (kl) => ajax( '/updateKL/'+ kl);
export const updateZylb = (lb) => ajax( '/updateLB/'+ lb);

// 根据gbdm查询院校详情
export const getSchoolDetail = (gb,zyz,pc)=>ajax( 
    '/querySchoolDetailed/'+ gb +'/'+ zyz+'/'+pc
    // '/querySchoolDetailed/'+ gb +'/'+ zyz
);
















                                            
